import { render, staticRenderFns } from "./AccountingDashboard.vue?vue&type=template&id=0d0ee24d&"
import script from "./AccountingDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports